export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Final2_04.f53ad527.jpg";